export const blockIconsAlertWarning = (
	<span className='material-symbols-outlined'>warning</span>
);
